<template>
    <div>
    </div>
</template>

<script>
export default {
    props: [
        'employerId',
        'email',
        'mykey',
        'env'
    ],
    data() {
        return {
            pusher: {
                all_users: null
            }
        };
    },
    methods: {
        onLinkCreated(link, employer_id, email, key) {
            if (this.mykey === key) {
                window.location.href = link;
            }
        }
    },
    mounted() {
        if (this.employerId) {
            this.pusher.all_users = Echo.private('jb-all-users');
            this.pusher.all_users.listen('.magic-link-created', (event) => {
                this.onLinkCreated(event.magic_link, event.employer_id, event.email, event.key);
            });

            setTimeout(() => {
              axios.post(url(`employer/portal/${this.employerId}/magic-link-request`), {
                'email': this.email,
                'key': this.mykey,
                'env': this.env
              });
            }, 1000);
        }
    },
    beforeDestroy() {
        this.pusher.all_users.stopListening('.magic-link-created');
    }
}
</script>